// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__DfAfb","inner":"Form_inner__3Vfzq","range":"Form_range__2_R7o","name":"Form_name__2DH1e","actions":"Form_actions__3KWMr"};